export const startOfDay = (day: Date): Date => {
  return new Date(day.getFullYear(), day.getMonth(), day.getDate());
};
